<template>
	<div class="flex flex_col equiplist-page">
		<!-- 上面的选择 -->
		<div class="selects">
			<el-form :model="queryParam" ref="ruleform" :inline="true" class="flex flex_ju_sb warnform-inline">
				<div class="form-inputs">
					<el-form-item label="所属网点">
						<el-select placeholder="请选择所属网点" v-model="queryParam.orgId" @change="handleChange">
							<el-option
								:label="item.orgName"
								:value="item.orgId"
								v-for="(item, index) in allSelect"
								:key="index"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="设备类型">
						<el-select placeholder="请选择" v-model="queryParam.deviceType" clearable>
							<el-option
								v-for="(item, index) in equipSelect"
								:key="index"
								:label="item.name"
								:value="item.id"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="设备编号" class="form-picker">
						<el-input placeholder="请输入" v-model="queryParam.deviceCode"></el-input>
					</el-form-item>
				</div>

				<el-form-item class="form-btns">
					<el-button type="primary" @click="searchClick">查询</el-button>
				</el-form-item>
			</el-form>
		</div>
		<!-- 下面的表格 -->
		<div class="flex flex_col warn-tables" v-loading="loading">
			<el-table
				:data="tableData"
				class="tables"
				:height="535"
				:stripe="true"
				align="center"
				header-cell-class-name="header-cell"
				cell-class-name="table-cell"
			>
				<el-table-column type="index" label="序号" width="180" align="center"> </el-table-column>
				<el-table-column prop="deviceTypeName" label="设备类型" width="180" align="center" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="deviceCode" label="设备编号" align="center" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="deviceName" label="设备名称" align="center" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="orgName" label="所属网点" align="center" show-overflow-tooltip> </el-table-column>
				<!-- 占位数据 -->
				<div slot="empty" class="table-empty">
					<img class="table-noimg" src="@/assets/image/home/img_none.png" alt="" />
					<div class="table-emptyword">请选择设备类型！</div>
				</div>
			</el-table>
			<!-- 分页 -->
			<el-pagination
				class="pagination"
				layout="prev, pager, next"
				:current-page.sync="ipagination.currentPage"
				:page-size="ipagination.pageSize"
				:total="ipagination.total"
				:hide-on-single-page="true"
				@current-change="handleCurrentChange"
			>
			</el-pagination>
		</div>
	</div>
</template>

<script>
/**
 * @description 首页子页面设备总数
 */
import tableMinin from '@/mixins/TableMinin'
export default {
	mixins: [tableMinin],
	data() {
		const self = this
		return {
			disableMixinCreated: false,
			isMakeTime: false,
			isTranPage: true, // 使用页码
			ifUseLoadBack: false,
			url: {
				list: self.$api.findDeviceList,
			},
			otherSelect: [
				{
					orgName: '全部',
					orgId: '',
				},
			],
			allSelect: [], // 网点的下拉选
			/**
             * 1：控制箱设备
2：水肥机设备
3：气象站设备
4：监控设备
5：土壤商情设备
6：测爆仪设备
7：杀虫灯设备
             */
			equipSelect: [
				{
					name: '控制箱设备',
					id: '1',
				},
				{
					name: '水肥机设备',
					id: '2',
				},
				{
					name: '气象站设备',
					id: '3',
				},
				{
					name: '监控设备',
					id: '4',
				},
				{
					name: '土壤墒情设备',
					id: '5',
				},
				{
					name: '测爆仪设备',
					id: '6',
				},
				{
					name: '杀虫灯设备',
					id: '7',
				},
			], // 设备类型下拉选
			// 表格数据
			tableData: [],
		}
	},
	mounted() {
		// 获取网点数据
		this.getSelectData()
	},
	methods: {
		// 获取网点数据
		getSelectData() {
			let userInfo = this.getItem('wlwUserInfo') || {}
			let userInfos = JSON.parse(userInfo)
			let params = {
				parentOrgId: userInfos.orgId,
				type: '2',
			}
			this.$http
				.getAction(this.$api.findChildOrgByParentOrgId, params)
				.then((res) => {
					console.log(res)
					if (res.meta.success) {
						let datas = res.data || []
						this.allSelect = this.otherSelect
						this.allSelect = this.allSelect.concat(datas)

						this.$set(this.queryParam, 'orgId', this.allSelect[0]['orgId'])
					} else {
						this.allSelect = []
					}
				})
				.catch((err) => {
					this.allSelect = []
				})
		},
		// 查询获取列表数据
		// loadData(arg) {
		// 	if (!this.url.list || this.url.list == '') {
		// 		this.$message('请设置url.list属性!', 'error')
		// 		return
		// 	}
		// 	if (arg === 1) {
		// 		this.ipagination.currentPage = 1
		// 	}
		// 	this.loading = true
		// 	let params = this.getQueryParams()

		// 	this.$http
		// 		.postAction(this.url.list, params)
		// 		.then((res) => {
		// 			console.log(res)
		// 			if (res.meta.success) {
		// 				let datas = res.data || {}
		// 				if (datas) {
		// 					// 分页数据的赋值
		// 					if (datas.totalElements) {
		// 						this.ipagination.total = Number(datas.totalElements)
		// 						this.ipagination.pageSize = datas.size
		// 					} else {
		// 						this.ipagination.total = 0
		// 						this.ipagination.pageSize = 10
		// 					}
		// 					// 判断走公共赋值还是单独数据处理
		// 					if (this.ifUseLoadBack) {
		// 						this.tableData = datas || []
		// 					} else {
		// 						// 回到页面各自独立的数据处理
		// 						this.loadBack(datas)
		// 					}
		// 				}
		// 			}
		// 		})
		// 		.finally((err) => {
		// 			this.loading = false
		// 		})
		// },
		// 网点选择
		handleChange(val) {
			if (val) {
				let orgIndex = this.allSelect.findIndex((item) => {
					return item.orgId == val
				})
				if (orgIndex > -1) {
					let orgItem = this.allSelect[orgIndex]
					this.$set(this.queryParam, 'orgCode', orgItem.orgCode)
					this.$set(this.queryParam, 'orgType', orgItem.orgType)
				}
			} else {
				this.$delete(this.queryParam, 'orgCode')
				this.$delete(this.queryParam, 'orgType')
			}
		},
	},
}
</script>
<style lang="scss" scoped>
.equiplist-page {
	height: 100%;
}
.warn-tables {
	padding-bottom: 0.15rem;

	flex: 1;
	min-height: 610px;
}
.table-empty {
	.table-emptyword {
		color: #797979;
		margin-top: 0.4rem;
		font-size: 0.17rem;
	}
}
</style>
